import { render, staticRenderFns } from "./ZztShenchaForm.vue?vue&type=template&id=60be0c30&"
import script from "./ZztShenchaForm.vue?vue&type=script&lang=js&"
export * from "./ZztShenchaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports